import { useEffect, useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";

const KEY = "sc_theme";
const order = ["system", "light", "dark"];
const icons = { system: Monitor, light: Sun, dark: Moon };

export function applyTheme(mode) {
  const sysDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  const dark = mode === "dark" || (mode === "system" && sysDark);
  document.documentElement.classList.toggle("light", !dark);
  document.documentElement.classList.toggle("dark", dark);
}

export function initTheme() {
  applyTheme(localStorage.getItem(KEY) || "system");
}

export default function ThemeToggle() {
  const [mode, setMode] = useState(localStorage.getItem(KEY) || "system");
  useEffect(() => { applyTheme(mode); localStorage.setItem(KEY, mode); }, [mode]);
  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    const h = () => mode === "system" && applyTheme("system");
    mq?.addEventListener?.("change", h);
    return () => mq?.removeEventListener?.("change", h);
  }, [mode]);
  const Icon = icons[mode];
  const next = () => setMode(order[(order.indexOf(mode) + 1) % order.length]);
  return (
    <button data-testid="theme-toggle" onClick={next} title={`Theme: ${mode} (click to change)`}
      className="rounded-lg p-2 text-slate-400 hover:text-white">
      <Icon className="h-5 w-5" />
    </button>
  );
}

// Best-effort IP deterrent. NOTE: a browser SPA always ships its code to the
// client - this only discourages casual inspection, it is not real protection.
export function CodeGuard() {
  useEffect(() => {
    const noCtx = (e) => e.preventDefault();
    const noKeys = (e) => {
      const k = e.key?.toLowerCase();
      if (e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && ["i", "j", "c"].includes(k)) ||
          (e.ctrlKey && k === "u")) {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener("contextmenu", noCtx);
    document.addEventListener("keydown", noKeys);
    return () => { document.removeEventListener("contextmenu", noCtx); document.removeEventListener("keydown", noKeys); };
  }, []);
  return null;
}
